export enum Route {
  //General Pages
  HOME = "/",
  NEWS_LIST = "/news-list",
  NEWS_DETAIL = "/news/:id",
  CONTACT = "/contact",
  CONTACT_CONFIRM = "/contact/confirm",
  CONTACT_COMPLETE = "/contact/complete",
  EXAMPLE = "/example",

  //Lottery
  LOTTERIES = "/lotteries",
  LOTTERY_DETAIL = "/lottery/:id",

  //User
  USER_LOGIN = "/user/login",
  USER_UNVERIFY = "/user/unverify",
  USER_UNVERIFY_COMPLETE = "/user/unverify/complete",
  USER_REGISTER = "/user/register",
  USER_REGISTER_CONFIRM_MAIL = "/user/register-confirm-email",
  USER_REGISTER_COMPLETE = "/user/register-complete",
  USER_PASSWORD_FORGOT = "/user/password-forgot",
  USER_PASSWORD_RESET = "/user/password/reset/:resetToken/:resetEmail",
  USER_PASSWORD_FORGOT_CONFIRM_MAIL = "/user/password-forgot-confirm-mail",
  USER_MYAPGE = "/user/mypage",
  USER_FAVORITE = "/user/favorite",
  USER_PURCHASED_HISTORY = "/user/purchased-history",
  USER_PURCHASED_HISTORY_DETAIL = "/user/purchased-history/:id",
  USER_PURCHASED_HISTORY_POINT = "/user/purchased-history-point",
  USER_PURCHASED_HISTORY_POINT_DETAIL = "/user/purchased-history-point/:id",
  USER_SHIPPING_ADDRESS = "/user/shipping-address",
  USER_CARD = "/user/card",

  CHECKOUT_SUCCESS = "/checkout-success",

  //Cart
  POINT = "/user/point",
  SHOPPING_CART = "/cart/shopping-cart",
  PAYMENT_METHOD = "/cart/payment-method",
  ORDER_CONFIRMATION = "/cart/order-confirmation",
  ORDER_COMPLETE = "/cart/order-complete",
  EFFECT_START = "/cart/effect-start",
  EFFECT_VIDEO = "/cart/effect-video",
  EFFECT_FINISH = "/cart/effect-finish",
  PRIZES = "/cart/prizes",

  POINT_EXCHANGE_COMPLETED = "/cart/point-exchange-completed",

  MAIL_COMPLETED = "/cart/point-mail-completed",

  SCRATCH_PAGE = "/cart/scratch",
  PRIZE_PAGE = "/cart/prize",
  PRIZE_RANK_PAGE = "/cart/prize-rank",

  //Static Pages

  STATIC_PAGE = "/static-pages/:name",

  STATIC_GUIDELINE = "/static-pages/guideline",
  STATIC_USAGE_POLICY = "/static-pages/usage-policy",
  STATIC_LEGAL = "/static-pages/legal-information",
  STATIC_POLICY = "/static-pages/privacy-policy",
  STATIC_COMPANY = "/static-pages/company",

  NOT_FOUND = "/not-found",
  ERROR = "/error",
}

export const ApiRoute = {
  LOTTERY_INDEX: "/lotteries",

  CATEGORIES: "/lotteries/category",

  LOTTERY_DETAIL: "/lottery",

  CONTACT: "/contact",

  NEWS_LIST: "/infos",
  NEWS_DETAIL: "/infos",

  POINTS: "/points",

  PURCHASE_TICKETS: "/purchased-tickets",

  PURCHASE_POINT: "/users/self/points-history",

  REDEEM_ALL_POINTS: "/redeem-all-points",

  REDEEM_POINTS: "/redeem-points",

  RECEIVED_PRIZE_MAIL: "/desired-prize",

  WITHDRAW_POINTS: "/withdraw-points",

  AUTH: {
    CHECK_AUTH: "/users/check-auth",
    LOGIN: "/users/login",
    REGISTER: "/users/register",
    OAUTH_TWITTER: "/users/oauth/twitter",
    OAUTH_FACEBOOK: "/users/oauth/facebook",
    LOGOUT: "/users/logout",

    SEND_RESET_PASSWORD_EMAIL: "/users/password/email",
    RESEND_VERIFY_EMAIL: "/users/email/resend",
    RESET_PASSWORD: "/users/password/reset",
  },

  CURRENT_USER: {
    SELF: "/users/self",
    ACCOUNT: "/users/self/account",
    ADDRESS: "/users/self/address",
    CARD: "/users/self/card",
    DEFAULT_CARD: "/users/self/default-card",
    LEAVE: "/users/self/leave",
    REGISTER_PAY_CUSTOMER_ID: "/users/self/regiser-pay-customer-id",
    FAVORITE: "/users/self/lottery/bookmark",

    POINTS: "/users/self/points",

    PURCHASE_HISTORY: {
      LIST: "/users/self/order",
    },
  },

  STATIC_API: "/pages",

  CART: {
    LIST: "/cart",
    VERIFY: "/cart/verify",
    ADD_CARD: "/cart/ticket",
    SHOP_CONFIG: "/cart/shop_config",
    DELETE: "/cart/ticket",
    ORDER: "/cart/order",
    COUPON: "/cart/coupon",
  },
};
